import { injectAsyncReducer } from '@lingoda/core';
import { STORE_KEY } from './constants';
import reducers from './reducers';
import initSideEffects from './side-effects';

export * from './actions';
export * from './models';
export * from './selectors';
export * from './utils';

injectAsyncReducer(STORE_KEY, reducers);
initSideEffects();
